<!-- eslint-disable vue/require-component-is -->
<template>
  <div class="modal-value-help">
    <Header
      ref="header-ref"
      :attrs="attrs"
      :multiple="multiple"
      :isBusy="isBusy"
      :isEditing="isEditing"
      :totalSelected="selectedValuesLength"
      :search.sync="search"
      @addNewData="handleAdd"
      @unselectAll="handleUnselectAll"
    />
    <div class="__table-container" ref="table-container-ref">
      <FormulateForm v-model="formValues" @submit="handleSubmit">
        <b-table
          ref="table-ref"
          show-empty
          selectable
          :select-mode="multiple ? 'multi' : 'single'"
          :no-select-on-click="this.isEditingRow !== null"
          :fields="computedFields"
          :items="items"
          :busy="isBusy"
          @row-clicked="handleRowClicked"
          class="-w-auto text-nowrap sticky-head-table border"
        >
          <!-- Slot: Empty -->
          <template #empty>
            <div v-show="!isBusy" class="text-center my-4">Tidak ada data</div>
          </template>

          <template #head(checkbox)>
            <div class="form-check">
              <input
                class="form-check-input me-1"
                type="checkbox"
                value="all"
                v-model="selectAll"
                @input="toggleAll"
              />
            </div>
          </template>

          <!-- Slot: Cell Checkbox -->
          <template #cell(checkbox)="{ index, item }">
            <div class="form-check">
              <b-form-checkbox
                v-model="selectedValues"
                :value="item[attrs.trackBy]"
                @change="handleCheckboxChange(item, index)"
              />
            </div>
          </template>

          <!-- Table Header -->
          <template #head()="data">
            <div @click="handleSortChange(data)">
              {{ data.label }}
              <template v-if="data.field.isSortable">
                <div v-if="showSortIcon(data, 'asc')" class="sort-icon-up">
                  <i class="mc-icon icon-outline_chevron-up"></i>
                </div>
                <div v-if="showSortIcon(data, 'desc')" class="sort-icon-down">
                  <i class="mc-icon icon-outline_chevron-down"></i>
                </div>
              </template>
            </div>
          </template>

          <!-- Table Data -->
          <template #cell()="{ index, field, value, item }">
            <template v-if="(field.editable || field.isEditable) && isEditingRow == index">
              <FormulateInput
                v-bind="field"
                :rowItem="item"
                :label="null"
                :type="field.type || 'text'"
                :disabled="isSubmitting"
                :help="field?.validation?.includes('required')"
                size="sm"
                validation-behavior="live"
                error-behavior="live"
              />
            </template>

            <template v-else>
              <slot v-if="field.isSlot" :name="field.name" :item="item">
                {{ value }}
              </slot>
              <template v-else>{{ formatValue(value, field) }}</template>
            </template>
          </template>

          <!-- Slot: Action Column (Last Column) -->
          <template #cell(action)="data">
            <div v-if="isEditingRow == data.index">
              <b-button variant="outline" class="__accept-button btn" type="submit">
                <i class="mc-icon icon-fill_checkmark"></i>
              </b-button>

              <b-button
                variant="outline"
                class="__cancel-button btn"
                @click="handleEditCancel(data)"
              >
                <i class="mc-icon icon-outline_close"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </FormulateForm>

      <!-- Observe visibility to get next page data -->
      <div v-observe-visibility="handleElementObserved" style="height: 1px"></div>

      <!-- Skeleton when getting the data -->
      <div v-if="isBusy && hasNextPage" class="px-2 py-2 d-flex gap-2">
        <b-skeleton width="2.5%"></b-skeleton>
        <b-skeleton width="97.5%"></b-skeleton>
      </div>
    </div>

    <!-- TODO: Enhance custom create modal in next feature development -->
    <component v-if="attrs['has:createModal']" v-bind="attrs" :is="attrs.customCreateModal" />
  </div>
</template>

<script>
import Header from './Header'
import isEmpty from 'lodash/isEmpty'

export default {
  components: {
    Header,
  },
  props: {
    isBusy: {
      type: Boolean,
      default: false,
    },

    isEditing: {
      type: Boolean,
      default: false,
    },

    selectedModel: {},

    fullObject: {},

    totalCount: {},

    attrs: {},

    listGetter: {},

    multiple: {
      type: Boolean,
      default: false,
    },
    geofenceAllData: {},
  },
  emits: ['update:isBusy', 'update:totalCount', 'update:isEditing'],
  data() {
    return {
      items: [],
      ids: [],
      sorts: [],
      page: 1,
      limit: 10,
      search: '',

      selectedValues: [],
      selectedObject: {},
      selectionType: '',
      formValues: {},
      isEditingRow: null,
      isSubmitting: false,
      isPagination: true,
      selectAll: false,
      selected: this.selectedModel,
      objects: this.fullObject,
      exclude: [],
      toggleSelectAll: false,
      totalItems: 0,
      initialGeofenceData: this.geofenceAllData,
      totalData: 0,
    }
  },
  computed: {
    computedFields() {
      if (!this.attrs.tableFields) return []

      const fields = [...this.attrs.tableFields]
      if (this.multiple) {
        fields.unshift({
          key: 'checkbox',
          label: '',
          thStyle: 'width:20px;',
        })
      }

      if (this.isEditingRow !== null) {
        fields.push({
          key: 'action',
          label: '',
          thClass: 'mc-action-col-head',
          tdClass: 'mc-action-cell',
        })
      }

      return fields
    },
    hasNextPage() {
      if (!this.isPagination) return false

      // If totalCount is null or undefined The data has not been fetched yet
      // so we return true to get the actual total count
      if (!this.totalCount) return true
      return this.page * this.limit < this.totalCount
    },
    selectedValuesLength() {
      return this.selectedValues.length
    },
  },
  watch: {
    async search(newValue) {
      const opts = {
        limit: this.limit,
        search: newValue != '' ? newValue : undefined,
        page: 1,
        sorts: this.sorts.map((sort) => `${sort.key} ${sort.order}`),
        sortArray: this.sorts,
      }
      await this.getData(opts, true)
      this.$refs['header-ref'].focusSearch()
    },

    selectedValues(value) {
      if (value.length >= this.totalItems) {
        this.toggleSelectAll = true
        this.selectAll = true
      } else {
        this.exclude = this.initialGeofenceData.filter(
          (item) => !this.selectedValues.includes(item.geofenceId)
        )
      }
    },
    totalItems(value) {
      if (value > 0 && this.selectedModel.length >= value) {
        this.selectAll = true
        this.toggleSelectAll = true
      } else {
        this.selectAll = false
      }
    },
  },
  mounted() {
    this.getData({
      limit: this.limit,
      search: this.search != '' ? this.search : undefined,
      sorts: this.sorts.map((sort) => `${sort.key} ${sort.order}`),
      sortArray: this.sorts,
    })
  },
  beforeDestroy() {
    this.handleHide()
  },
  methods: {
    reloadValue() {
      this.selectedValues = []
      if (this.multiple && isEmpty(this.selected)) return
      if (this.selected == '' || this.selected == null) return

      const selected = this.multiple ? this.selected : [this.selected]
      // set keys in selectedValues
      selected.forEach((value) => {
        this.selectedValues.push(value)
      })

      // if there is no fullObject from parent
      if (isEmpty(this.objects) || this.objects == undefined) return

      const objects = this.multiple ? this.objects : [this.objects]

      // set fullObject in selectedObject
      objects.forEach((obj) => {
        this.$set(this.selectedObject, obj[this.attrs.trackBy], obj)
      })
    },
    sortData(items, columnsToSort) {
      items.sort((a, b) => {
        let orderResult = 0
        for (let cts of columnsToSort) {
          const { key, order } = cts
          const modifier = order === 'asc' ? 1 : -1

          let data1 = a[key]
          let data2 = b[key]

          // Actual sorting
          if (typeof data1 === 'string' && typeof data2 === 'string') {
            const compare = data1.localeCompare(data2)
            orderResult = compare * modifier
            if (compare !== 0) break
          } else if (data1 < data2 || (data1 === null && data2 !== null)) {
            orderResult = -1 * modifier
            break
          } else if (data1 > data2 || (data1 !== null && data2 === null)) {
            orderResult = 1 * modifier
            break
          }
        }

        return orderResult
      })
    },

    handleAdd() {
      if (this.attrs['has:createModal']) {
        this.$bvModal.show(`${this.attrs.name}-create-data-modal`)
        return
      }

      this.$emit('update:isEditing', true)

      if (this.isEditingRow != null) return
      this.isEditingRow = 0

      this.items = [{ id: 0 }, ...this.items]
    },
    HandleApply() {
      const isSelectingAllGeofences = this.selectAll && !this.search

      if (isSelectingAllGeofences) {
        this.exclude = []
        this.geofenceAllData.map((item) => {
          if (!this.selectedValues.includes(item.geofenceId)) this.exclude.push(item)
        })
      }

      return {
        selectedValues: this.selectedValues,
        selectedObject: this.selectedObject,
        selectAll: isSelectingAllGeofences,
        exclude: this.exclude,
      }
    },
    handleHide() {
      this.items = []
      this.ids = []
      this.sorts = []
      this.page = 1
      this.search = ''

      this.isEditingRow = null
      this.isSubmitting = false
    },
    async getData(opts, reset = false) {
      if (!reset) {
        this.reloadValue()
      }
      this.$emit('update:isBusy', true)

      if (!this.listGetter) {
        this.$emit('update:isBusy', false)
        return
      }

      const { sortArray, ...otherOpts } = opts
      if (!opts.page) return
      const res = await this.listGetter(otherOpts)

      if (!res || res.errors) return

      this.items = reset ? res.data.paginated_result : [...this.items, ...res.data.paginated_result]

      this.page = res.metadata.page
      this.totalItems = res.metadata.total_count
      if (opts.sortArray?.length > 0) this.sortData(this.items, sortArray)
      this.ids = this.items.map((item) => item.geofenceId)

      this.$emit('update:totalCount', this.totalItems)

      this.$emit('update:isBusy', false)

      this.handleCheckSelectAll()
      await this.$nextTick()
      this.highlightSelectedRow()
    },

    highlightSelectedRow() {
      const trackBy = this.attrs.trackBy
      this.selectedValues.forEach((value) => {
        const index = this.items.findIndex((item) => item[trackBy] == value)

        // Toggle the row checkbox
        if (index !== -1) {
          this.$refs['table-ref'].selectRow(index)
        }
      })
    },

    showSortIcon(data, order) {
      const currentColumnSort = this.sorts.find((sort) => sort.key === data.field.key)
      if (!currentColumnSort) {
        return true
      }

      return currentColumnSort.key === data.field.key && currentColumnSort.order === order
    },

    async handleSortChange(data) {
      if (this.isEditing) return

      if (!data) {
        this.sorts = []
        return
      }

      if (!data?.field?.isSortable) return

      const currentColumnSortIndex = this.sorts.findIndex((sort) => sort.key === data.field.key)
      const currentColumnSort = this.sorts[currentColumnSortIndex]
      const newSorts = [...this.sorts]
      switch (currentColumnSort?.order) {
        case 'asc':
          newSorts[currentColumnSortIndex] = {
            key: currentColumnSort.key,
            order: 'desc',
          }
          break

        case 'desc':
          newSorts.splice(currentColumnSortIndex, 1)
          break

        default:
          newSorts.push({ key: data.field.key, order: 'asc' })
          break
      }

      this.sorts = [...newSorts]
      await this.$nextTick()

      await this.getData(
        {
          limit: this.limit,
          page: 1,
          search: this.search != '' ? this.search : undefined,
          sorts: this.sorts.map((sort) => `${sort.key} ${sort.order}`),
          sortArray: this.sorts,
        },
        true
      )
    },
    handleRowClicked(item, index) {
      if (!this.multiple) {
        this.selectedValues = []
        this.selectedObject = {}
      }

      const trackBy = this.attrs.trackBy
      const checked = this.selectedValues.find((val) => val == item[trackBy])

      if (checked) {
        this.selectedValues = this.selectedValues.filter((val) => val !== item[trackBy])
        this.selected = this.selectedValues
        this.$refs['table-ref'].selectRow(index)
        this.$delete(this.selectedObject, item[trackBy])
        return
      }
      this.selectedValues.push(item[trackBy])
      this.selected = this.selectedValues
      this.$refs['table-ref'].unselectRow(index)
      this.$set(this.selectedObject, item[trackBy], item)

      this.handleCheckSelectAll()
    },
    handleCheckboxChange(item, index) {
      if (!this.multiple) {
        this.selectedObject = {}
      }

      const trackBy = this.attrs.trackBy
      const checked = this.selectedValues.find((val) => val == item[trackBy])

      if (!checked) {
        this.$refs['table-ref'].unselectRow(index)
        this.selected = this.selectedValues
        this.$delete(this.selectedObject, item[trackBy])
        return
      }
      this.$refs['table-ref'].selectRow(index)
      this.selected = this.selectedValues
      this.$set(this.selectedObject, item[trackBy], item)

      this.handleCheckSelectAll()
    },

    handleCheckSelectAll() {
      if (this.totalItems > 0 && this.selectedModel.length == this.totalItems) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    },

    toggleAll(event) {
      let checked = event.target.checked

      if (checked) {
        this.handleSelectAll()
      } else {
        this.handleUnselectAll()
      }
    },

    handleUnselectAll() {
      this.selectAll = false
      this.selectedObject = {}
      this.selectedValues = []

      this.$refs['table-ref'].clearSelected()
    },

    async handleSelectAll() {
      if (this.attrs.trackBy === 'geofenceId') {
        this.selectAll = true

        let geofences = this.geofenceAllData

        if (this.search) {
          this.$emit('update:isBusy', true)
          const res = await this.listGetter({
            limit: this.totalItems,
            page: 1,
            search: this.search,
            sorts: this.sorts.map((sort) => `${sort.key} ${sort.order}`),
          })
          this.$emit('update:isBusy', false)

          if (!res || res.errors) {
            this.selectAll = false
            return
          }

          geofences = res.data.paginated_result
        }

        geofences.forEach((item) => {
          if (!this.selectedValues.includes(item.geofenceId))
            this.selectedValues.push(item.geofenceId)
          this.selected = this.selectedValues

          this.$set(this.selectedObject, item.geofenceId, item)
        })
        this.$refs['table-ref'].selectAllRows()
      } else {
        throw new Error('Select all is not yet implemented when trackBy is not geofenceId')
      }
    },

    transformFields(formValues, fields) {
      const formValuesKeys = Object.keys(formValues)
      const validKeys = formValuesKeys.filter((key) => formValues[key] !== false)

      return Object.assign(
        {},
        ...validKeys.map((key) => {
          const currentField = fields.find((item) => item.key == key)
          const value = formValues[key]

          if (currentField && currentField._type === 'number') {
            const isValid = Boolean(value) || value === '0' || value === 0
            return { [key]: isValid ? Number(value) : null }
          } else if (currentField && currentField.type === 'text') {
            return { [key]: formValues[key].trim().replace(/  +/g, ' ') }
          }

          return { [key]: value }
        })
      )
    },
    async submitStore(data) {
      const createdData = await this.attrs.apiClient.store(data)
      if (createdData.errors) return createdData

      const refetchedData = await this.attrs.apiClient.show(createdData.data.geofenceId)
      if (refetchedData.errors) return refetchedData

      this.ids.push(refetchedData.data.geofenceId)
      this.$emit('update:totalCount', this.totalCount + 1)

      this.$mcToast.success('Data berhasil ditambahkan')

      return {
        ...data,
        ...refetchedData.data,
      }
    },
    async handleSubmit(data) {
      if (this.isSubmitting) {
        this.$mcToast.warning('Mohon tunggu')
        return
      }

      this.isSubmitting = true

      const transformedData = this.transformFields(data, this.computedFields)

      let newData = null
      newData = await this.submitStore(transformedData)

      if (newData.errors) {
        this.isSubmitting = false
        return
      }

      // Replace data on the table
      if (newData !== null) {
        this.items.splice(this.isEditingRow, 1, newData)
      }

      this.isEditingRow = null
      this.isSubmitting = false
      await this.$nextTick()

      this.handleRowClicked(newData, 0)

      // to highlight the new row
      this.$refs['table-ref'].selectRow(0)
      this.$emit('update:isEditing', false)
    },
    async handleEditCancel() {
      if (this.isSubmitting) return

      const [, ...newItems] = this.items
      this.items = newItems
      this.isEditingRow = null
      await this.$nextTick()

      this.highlightSelectedRow()
      this.$emit('update:isEditing', false)
    },
    formatValue(value, field) {
      if (field.formatValue === undefined) {
        return value
      }

      return field.formatValue(value)
    },
    handleElementObserved(isVisible) {
      if (!isVisible) return
      if (!this.hasNextPage) return

      if (this.items.length == 0 && this.search) return

      this.getData({
        limit: this.limit,
        page: this.totalCount ? ++this.page : this.page,
        search: this.search != '' ? this.search : undefined,
        sorts: this.sorts.map((sort) => `${sort.key} ${sort.order}`),
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.__table-container {
  border: 1px solid #ebecef;
  height: 300px;
  overflow-y: auto;

  :deep(.table) {
    --bs-table-active-bg: #e9f2fc;

    thead {
      tr {
        th {
          position: relative;
          &:has(.sort-icon-up),
          &:has(.sort-icon-down) {
            padding-right: 30px;
          }

          .sort-icon-up {
            position: absolute;
            right: 10px;
            top: 8px;
            opacity: 0.7;
          }
          .sort-icon-down {
            position: absolute;
            right: 10px;
            bottom: 8px;
            opacity: 0.7;
          }
        }
      }
    }

    // Action column
    .mc-action-col-head {
      width: 80px;
    }

    // Action cell
    .mc-action-cell {
      vertical-align: middle;

      & > div {
        display: flex;
        padding: 0 4px;
        justify-content: space-between;
      }

      .mc-icon:before {
        font-size: 20px;
      }

      .btn {
        padding: 0;
      }

      .btn:hover {
        border-color: transparent;
      }

      .__cancel-button .mc-icon:before {
        color: $danger;
      }

      .__disabled .mc-icon:before {
        opacity: $btn-disabled-opacity;
        cursor: not-allowed;
      }

      .__accept-button .mc-icon:before {
        color: $success;
      }
    }
  }
}
</style>
